import React from "react"
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom"
import styled from "@emotion/styled"
import LeftPanel from "./LeftPanel"
import Header from "./Header"
import Home from "components/Pages/Home"
import NotFound from "components/Pages/NotFound"
import Expert from "components/Pages/Expert"
import Profile from "components/Pages/Profile"
import Category from "components/Pages/Category"
import Program from "components/Pages/Program"
import Faq from "components/Pages/Faq"
import Modal from "components/Pages/Modal"
import Review from "components/Pages/Review"
import Media from "components/Pages/Media"
import { Member } from "components/Pages/Member"
import MemberDsar from "components/Pages/MemberDsar/MemberDsar"
import BetaTesters from "components/Pages/BetaTesters"
import Permission from "components/Pages/Permission"
import Role from "components/Pages/Role"
import Admin from "components/Pages/Admin"
import SystemSetting from "components/Pages/SystemSetting"
import SubscriptionProduct from "components/Pages/SubscriptionProduct"
import Marketplace from "components/Pages/Marketplace/Marketplace"
import Order from "components/Pages/Order"
import StartHere from "components/Pages/StartHere/StartHere"
import Rails from "components/Pages/Rails"
import Redis from "components/Pages/Redis"
import SystemConfig from "components/Pages/SystemConfig/SystemConfig"
import NpsQuestions from "components/Pages/NpsQuestions"
import ProductGates from "components/Pages/ProductGates"
import AiAgent from "components/Pages/AiAgent"
import AiVoices from "components/Pages/AiVoices"
import AiStudyLab from "components/Pages/AiStudyLab"
import SharedKnowledgeBase from "components/Pages/SharedKnowledgeBase"
import Event from "components/Pages/Event"
import McpPlatform from "components/Pages/McpPlatform"
import ReportedPosts from "components/Pages/Community/ReportedPosts"
import ReportedComments from "components/Pages/Community/ReportedComments"
import Badges from "components/Pages/Badges/Badges"
import PeriodicReportSettings from "components/Pages/PeriodicReports/PeriodicReportSettings"
import BetaFeatures from "components/Pages/BetaFeatures/BetaFeatures"
import NeuroFitnessGames from "components/Pages/NeuroFitnessGames/NeuroFitnessGames"
import Onboarding from "components/Pages/Onboarding/Onboarding"
import OnboardingSeries from "components/Pages/OnboardingSeries/OnboardingSeries"
//------------------------------------------
// lazy load component example
//------------------------------------------
const Login = React.lazy(() => import("components/Pages/Login"))

const RouterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--cms-app-bg);
  color: var(--cms-text-primary);
`

const StyledBody = styled.div`
  display: flex;
  height: calc(100vh - 64px);
`
const ContentPanel = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  background: var(--cms-content-bg);
  color: var(--cms-text-primary);
  transition: background 0.2s ease, color 0.2s ease;
`

const HomeLessonsInsights = () => <Home insightsView="lessons" />
const HomeUsersInsights = () => <Home insightsView="users" />
const HomeAiInsights = () => <Home insightsView="ai" />
const HomeEventsInsights = () => <Home insightsView="events" />
const HomeEmailsInsights = () => <Home insightsView="emails" />
const HomeNpsInsights = () => <Home insightsView="nps" />

const CmsTemplate = (PageComponent) => {
  return (
    <>
      <Header />
      <StyledBody>
        <LeftPanel />
        <ContentPanel className="cms-content-panel">
          <div className="cms-page-shell">
            <PageComponent />
          </div>
        </ContentPanel>
      </StyledBody>
    </>
  )
}

const WebRoutes = () => {
  return (
    <React.Suspense fallback={null}>
      <RouterWrapper>
        <Router>
          <Routes>
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/" element={CmsTemplate(Home)} />
            <Route
              path="/insights"
              element={<Navigate to="/insights/overview" replace />}
            />
            <Route
              exact
              path="/insights/overview"
              element={CmsTemplate(Home)}
            />
            <Route
              exact
              path="/insights/users"
              element={CmsTemplate(HomeUsersInsights)}
            />
            <Route
              exact
              path="/insights/ai"
              element={CmsTemplate(HomeAiInsights)}
            />
            <Route
              exact
              path="/insights/lessons"
              element={CmsTemplate(HomeLessonsInsights)}
            />
            <Route
              exact
              path="/insights/events"
              element={CmsTemplate(HomeEventsInsights)}
            />
            <Route
              exact
              path="/insights/emails"
              element={CmsTemplate(HomeEmailsInsights)}
            />
            <Route
              exact
              path="/insights/nps"
              element={CmsTemplate(HomeNpsInsights)}
            />
            <Route exact path="/profile" element={CmsTemplate(Profile)} />
            <Route exact path="/category" element={CmsTemplate(Category)} />
            <Route exact path="/program" element={CmsTemplate(Program)} />
            <Route exact path="/faq" element={CmsTemplate(Faq)} />
            <Route exact path="/modal" element={CmsTemplate(Modal)} />
            <Route exact path="/review" element={CmsTemplate(Review)} />
            <Route
              path="/mcp-platform"
              element={<Navigate to="/mcp-platform/review" replace />}
            />
            <Route exact path="/mcp-platform/review" element={CmsTemplate(McpPlatform)} />
            <Route exact path="/mcp-platform/users" element={CmsTemplate(McpPlatform)} />
            <Route exact path="/mcp-platform/audit" element={CmsTemplate(McpPlatform)} />
            <Route exact path="/ai-review" element={<Navigate to="/mcp-platform/review" replace />} />
            <Route exact path="/mcp-users" element={<Navigate to="/mcp-platform/users" replace />} />
            <Route exact path="/mcp-audit-log" element={<Navigate to="/mcp-platform/audit" replace />} />
            <Route exact path="/media" element={CmsTemplate(Media)} />
            <Route exact path="/member" element={CmsTemplate(Member)} />
            <Route exact path="/betaTesters" element={CmsTemplate(BetaTesters)} />
            <Route exact path="/member-dsar" element={CmsTemplate(MemberDsar)} />
            <Route exact path="/badges" element={CmsTemplate(Badges)} />
            <Route exact path="/permission" element={CmsTemplate(Permission)} />
            <Route exact path="/role" element={CmsTemplate(Role)} />
            <Route exact path="/admin" element={CmsTemplate(Admin)} />
            <Route exact path="/order" element={CmsTemplate(Order)} />
            <Route exact path="/startHere" element={CmsTemplate(StartHere)} />
            <Route exact path="/expert" element={CmsTemplate(Expert)} />
            <Route exact path="/rail" element={CmsTemplate(Rails)} />
            <Route exact path="/redis" element={CmsTemplate(Redis)} />
            <Route exact path="/community/reports" element={CmsTemplate(ReportedPosts)} />
            <Route exact path="/community/reports/comments" element={CmsTemplate(ReportedComments)} />
            <Route
              exact
              path="/systemConfig"
              element={CmsTemplate(SystemConfig)}
            />
            <Route
              exact
              path="/npsQuestions"
              element={CmsTemplate(NpsQuestions)}
            />
            <Route
              exact
              path="/periodicReports"
              element={CmsTemplate(PeriodicReportSettings)}
            />
            <Route
              exact
              path="/onboarding"
              element={CmsTemplate(Onboarding)}
            />
            <Route
              exact
              path="/onboardingSeries"
              element={CmsTemplate(OnboardingSeries)}
            />
            <Route
              exact
              path="/betaFeatures"
              element={CmsTemplate(BetaFeatures)}
            />
            <Route
              exact
              path="/neuroFitnessGames"
              element={CmsTemplate(NeuroFitnessGames)}
            />
            <Route
              exact
              path="/productGates"
              element={CmsTemplate(ProductGates)}
            />
            <Route
              exact
              path="/aiAgent"
              element={CmsTemplate(AiAgent)}
            />
            <Route
              exact
              path="/ai-voices"
              element={CmsTemplate(AiVoices)}
            />
            <Route
              exact
              path="/ai-study-lab"
              element={CmsTemplate(AiStudyLab)}
            />
            <Route
              exact
              path="/knowledge-base"
              element={CmsTemplate(SharedKnowledgeBase)}
            />
            <Route
              exact
              path="/event"
              element={CmsTemplate(Event)}
            />
            <Route
              exact
              path="/systemSetting"
              element={CmsTemplate(SystemSetting)}
            />
            <Route
              exact
              path="/product"
              element={CmsTemplate(SubscriptionProduct)}
            />
            <Route
              exact
              path="/marketplace"
              element={CmsTemplate(Marketplace)}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </RouterWrapper>
    </React.Suspense>
  )
}

export default WebRoutes
